module.exports={graphics:"Usamos recursos gráficos con las siguientes licencias",title:"Licencias de terceros"};